import {on} from 'delegated-events'

on('upload:setup', '.js-upload-repository-image', function () {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('.js-remove-repository-image-button')!.hidden = true
})

on('upload:complete', '.js-upload-repository-image', function (event) {
  const {attachment} = event.detail
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLInputElement>('.js-repository-image-id')!.value = attachment.id
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('.js-remove-repository-image-button')!.hidden = false
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('.js-repository-image-container')!.style.backgroundImage =
    `url(${attachment.href})`
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('.js-repository-image-container')!.hidden = false
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLElement>('#edit-social-preview-button')!.classList.add(...['position-absolute', 'ml-2'])
})
